import React, { useState } from "react";
import "../styles/Form.css";
import { saveInquiry } from "../api/inquiries";
import SuccessPopup from "./SuccessPopup";
import FailurePopup from "./FailurePopup";

const Form = () => {
  const [isOpen, setIsOpen] = useState(false);
  const [formData, setFormData] = useState({
    name: "",
    phone: "",
    email: "",
    consent: false,
  });
  const [errors, setErrors] = useState({});
  const [loading, setLoading] = useState(false);
  const [showPopup, setShowPopup] = useState(false);
  const [showFailurePopup, setShowFailurePopup] = useState(false);

  // Handle input change
  const handleChange = (e) => {
    const { name, value, type, checked } = e.target;

    // Phone validation (only digits & max 10 chars)
    if (name === "phone") {
      if (/^\d{0,10}$/.test(value)) {
        setFormData((prev) => ({ ...prev, [name]: value }));
      }
      return;
    }

    setFormData((prev) => ({
      ...prev,
      [name]: type === "checkbox" ? checked : value,
    }));
  };

  // Validate form
  const validateForm = () => {
    const newErrors = {};

    if (!formData.name.trim()) {
      newErrors.name = "Name is required";
    } else if (!/^[A-Za-z\s]+$/.test(formData.name.trim())) {
      newErrors.name = "Name can only contain letters and spaces";
    }

    if (!formData.phone.trim()) {
      newErrors.phone = "Phone number is required";
    } else if (!/^\d{10}$/.test(formData.phone)) {
      newErrors.phone = "Please enter a valid 10-digit number";
    }

    if (!formData.email.trim()) {
      newErrors.email = "Email is required";
    } else if (!/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(formData.email)) {
      newErrors.email = "Please enter a valid Email address";
    }

    if (!formData.consent) {
      newErrors.consent = "Please accept the consent to proceed";
    }

    setErrors(newErrors);
    return Object.keys(newErrors).length === 0;
  };

  // Handle submit
  const handleSubmit = async (e) => {
    e.preventDefault();

    if (!validateForm()) return;

    const now = new Date();
    const offsetMs = 5.5 * 60 * 60 * 1000; // IST = UTC + 5h30m
    const istTime = new Date(now.getTime() + offsetMs);
    const inquiry_datetime = istTime.toISOString().replace("T", " ").split(".")[0];

    const payload = {
      inquiry_datetime,
      name: formData.name,
      email: formData.email,
      phone: formData.phone,
    };

    setLoading(true);
    try {
      await saveInquiry(payload);
      // alert("Thank you for your interest! We will contact you soon.");
      setShowPopup(true);
      setFormData({ name: "", phone: "", email: "", consent: false });
      setErrors({});
    } catch (err) {
      console.error(err);
      // alert("Failed to submit inquiry. Please try again later.");
      setShowFailurePopup(true);
    } finally {
      setLoading(false);
    }
  };

  return (
    <div
      className={`form-wrapper ${isOpen ? "open" : ""}`}
      onMouseEnter={() => setIsOpen(true)}
    // onMouseLeave={() => setIsOpen(false)}
    >
      {/* Enquire Now Tab */}
      <div className="enquire-tab">
        <span>Enquire Now</span>
      </div>

      {/* Sliding Form */}
      <div className="form-container">
        <h3>Book a Private Site Visit</h3>
        <button
          type="button"
          className="close-btn"
          onClick={() => setIsOpen(false)}
        >
          ✕
        </button>

        <form onSubmit={handleSubmit}>
          <label>Full Name</label>
          <input
            type="text"
            name="name"
            placeholder="Full Name"
            value={formData.name}
            onChange={handleChange}
          />
          {errors.name && <p className="error-text1">{errors.name}</p>}

          <label>Phone Number</label>
          <input
            type="text"
            name="phone"
            placeholder="Phone Number"
            value={formData.phone}
            onChange={handleChange}
          />
          {errors.phone && <p className="error-text1">{errors.phone}</p>}

          <label>Email Address</label>
          <input
            type="email"
            name="email"
            placeholder="Email Address"
            value={formData.email}
            onChange={handleChange}
          />
          {errors.email && <p className="error-text1">{errors.email}</p>}

          <div className="checkbox">
            <input
              type="checkbox"
              id="consent"
              name="consent"
              checked={formData.consent}
              onChange={handleChange}
            />
            <label htmlFor="consent" className="con">
              I authorize company representatives to Call, SMS, Email or WhatsApp
              me about its products and offers. This consent overrides any
              registration for DNC/NDNC.
            </label>
          </div>
          {errors.consent && <p className="error-text1">{errors.consent}</p>}

          <button type="submit" className="form-btn" disabled={loading}>
            {loading ? "Submitting..." : "Book Now"}
          </button>
        </form>
      </div>

      {showPopup && (
  <SuccessPopup
    message="Thank you for your interest! We will contact you soon."
    onClose={() => setShowPopup(false)}
  />
)}

{showFailurePopup && (
  <FailurePopup
    message="Failed to submit your inquiry. Please try again later."
    onClose={() => setShowFailurePopup(false)}
  />
)}

    </div>
  );
};

export default Form;
